export enum CouponType {
  amountInCt = "amountInCt",
  percentage = "percentage"
}
